export default {
  state: {
    paymentMethods: [],
    loading: false,
  },
  getters: {
    paymentMethods: state => state.paymentMethods,
    loading: state => state.loading,
  },
  mutations: {
    setPaymentMethods(state, paymentMethods) {
      state.paymentMethods = paymentMethods;
    },
    setLoading(state, loading) {
      state.loading = loading;
    },
  },
  actions: {
    async fetchAll({ commit }) {
      commit('setLoading', true);
      try {
        const paymentMethods = await axios.get('api/payment-methods');
        commit('setPaymentMethods', paymentMethods);
      } catch (e) {
      }
      commit('setLoading', false);
    },
  },
};
